import React from 'react';
import type ListWorkflows from '@atlassian/jira-admin-pages-list-workflows/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyListWorkflows = lazyForPaint<typeof ListWorkflows>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-admin-pages-list-workflows", jiraSpaEntry: "async-admin-pages-list-workflows" */ '@atlassian/jira-admin-pages-list-workflows'
		),
	),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage Page={LazyListWorkflows} pageId="jira-admin-pages-list-workflows" shouldShowSpinner />
);
